import { ArrowBack, ArrowForward } from '@material-ui/icons';
import { Drawer, IconButton, List, ListItem, ListItemText, Typography, withStyles, withTheme } from 'material-ui';
import React, { Component } from 'react';
import Message from '../components/Message';
import ResourceIndexGrid from '../components/ResourceIndexGrid';
import SubHeader from '../components/SubHeader';
import DocumentContent from '../resource_content/DocumentContent';
import TermContent from '../resource_content/TermContent';

const drawerWidth = 240;

const styles = {
  drawer_paper: {
    top: 56,
    height: 'calc(100vh - 56px)',
    '@media (min-width:0px) and (orientation: landscape)': {
      top: 48,
      height: 'calc(100vh - 48px)',
    },
    '@media (min-width:600px)': {
      top: 64,
      height: 'calc(100vh - 64px)',
    },
    width: drawerWidth,
    '@media (max-width:599.95px)': {
      display: 'none'
    }
  },

  sub_header: {
    top: 56,
    left: drawerWidth,
    width: 'calc(100vw - ' + drawerWidth + 'px)',
    '@media (min-width:0px) and (orientation: landscape)': {
      top: 48
    },
    '@media (min-width:600px)': {
      top: 64
    },
    '@media (max-width:599.95px)': {
      left: 0,
      width: '100vw'
    }
  },

  content: {
    marginTop: 112,
    '@media (min-width:0px) and (orientation: landscape)': {
      marginTop: 96,
    },
    '@media (min-width:600px)': {
      marginTop: 128,
    },
    marginLeft: drawerWidth,
    '@media (max-width:599.95px)': {
      marginLeft: 0
    }
  },

  text_content: {
    background: 'white',
    padding: 24,
    minHeight: 'calc(100vh - 112px)',
    '@media (min-width:0px) and (orientation: landscape)': {
      minHeight: 'calc(100vh - 96px)',
    },
    '@media (min-width:600px)': {
      minHeight: 'calc(100vh - 128px)',
    }
  }
}

class Collection extends Component {
  render() {
    var info = this.props.resources[this.props.resourceID];
    var collected = info.collected;
    var collectedIndex = 0;
    try {
      collectedIndex = Number(window.location.hash.slice(1));
    }catch(e){}
    return (
      <React.Fragment>
        <Drawer variant='permanent' classes={{paper: this.props.classes.drawer_paper}}>
          <List>
            {
              collected.map((resourceID, index)=>{
                var resourceInfo = this.props.resources[resourceID];
                if(resourceInfo) {
                  return (
                    <ListItem button onClick={()=>{window.history.pushState(null, null, '#' + index); this.forceUpdate()}} key={index}>
                      <ListItemText primary={resourceInfo.name} />
                    </ListItem>
                  );
                }else {
                  console.error('Resource not found', resourceID, index);
                  return null;
                }
              })
            }
          </List>
        </Drawer>

        <SubHeader className={this.props.classes.sub_header}>
          <div style={{flexGrow: 1}}>
            <Typography variant="title" color='inherit'>
              {info.name}
            </Typography>
            <Typography variant="subheading" color='inherit'>
              {this.props.resources[collected[collectedIndex]].name}
            </Typography>
          </div>

          <IconButton disabled={collectedIndex === 0} onClick={()=>{window.history.pushState(null, null, '#' + (collectedIndex - 1)); this.forceUpdate()}}>
            <ArrowBack/>
          </IconButton>

          <IconButton disabled={collectedIndex >= collected.length - 1} onClick={()=>{window.history.pushState(null, null, '#' + (collectedIndex + 1)); this.forceUpdate()}}>
            <ArrowForward/>
          </IconButton>
        </SubHeader>

        <main className={this.props.classes.content}>
          {this.renderCollectedResource(collected[collectedIndex])}
        </main>
      </React.Fragment>
    );
  }

  renderCollectedResource(resourceID) {
    var resourceInfo = this.props.resources[resourceID];
    if(resourceInfo) {
      if(resourceInfo.type === 'document') {
        return (
          <div className={this.props.classes.text_content}>
            <DocumentContent resourceID={resourceID} resources={this.props.resources}/>
          </div>
        );
      }else if(resourceInfo.type === 'term') {
        return (
          <div className={this.props.classes.text_content}>
            <TermContent resourceID={resourceID} resources={this.props.resources}/>
          </div>
        );
      }else if(resourceInfo.type === 'index') {
        return (
          <div style={{paddingTop: 12, paddingBottom: 12}}>
            <ResourceIndexGrid resources={this.props.resources} indexed={resourceInfo.indexed} gridItemProps={{xs: 12, sm: 12, md: 6, lg: 4, xl: 3}}/>
          </div>
        );
      }
    }
    return <Message>Unable to render resource.</Message>
  }
}

export default withTheme()(withStyles(styles)(Collection));


// WEBPACK FOOTER //
// ./src/resource_views/Collection.js